import JoinLink from './JoinLink';
export default JoinLink;
